import namespace from '../namespace';

export default [...namespace, 'teamTargetPage'];
